<template>
  <div class="container-fluid py-3 px-4">
    <div class="border border-1 rounded-3 p-3 mb-3 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-person-badge display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            BASE GENERAL DE PUESTOS
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            PUESTOS NUEVOS
          </p>
        </div>
      </div>
    </div>
    <!-- @submit.prevent="guardar" -->
    <form action="" @submit.prevent="guardar">
      <div class="mt-2 pb-2">
        <div class="border border-1 rounded-3 p-3 mb-3">
          <div class="row gy-2 gx-3">
            <div class="col-md-12 ">
              <b-alert show variant="danger" v-if="alertaError">
                <a href="#" class="alert-link">¡FALTA COMPLETAR LOS CAMPOS!</a>
              </b-alert>

              <b-alert show variant="danger" v-if="puestoExiste">
                <i class="bi bi-exclamation-octagon-fill me-2"></i> EL PUESTO <span class="fw-bold">"{{ from.PtoNombre }}"</span> YA EXISTE EN LA BASE DE DATOS.
              </b-alert>
            </div>

            <div class="col-lg-2 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-briefcase fs-6 text-danger"></i> PUESTO:</label>
              <input type="text" required class="form-control tamaño2" v-model="from.PtoNombre"
                placeholder="NOMBRE DEL PUESTO..." 
                @input="from.PtoNombre = from.PtoNombre.replace(/^\s+/, '').replace(/\s{2,}/g, ' ')"
                @blur="from.PtoNombre = from.PtoNombre.trim()" />

            </div>

            <div class="col-lg-2  col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-building fs-6 text-success"></i> SECTOR:</label>
              <select v-model="from.PtoSector" required class="form-control tamaño2">
                <option disabled value="">-- SELECCIONA UN SECTOR --</option>
                <option :value="{
                  id: sectores.parCorrelativo,
                  descripcion: sectores.parDescripcion
                }" v-for="sectores in Sector" :key="sectores.id">
                  {{ sectores.parDescripcion }}
                </option>
              </select>
            </div>

            <div class="col-lg-2 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-tag text-info fs-6"></i> CLASIFICACION:</label>
              <select v-model="from.PtoClasificacion" required class="form-control tamaño2">
                <option disabled value="">
                  -- SELECCIONA UNA CLASIFICACION --
                </option>
                <option :value="{
                  id: clasificar.parCorrelativo,
                  descripcion: clasificar.parDescripcion
                }" v-for="clasificar in Clasificacion" :key="clasificar.id">
                  {{ clasificar.parDescripcion }}
                </option>
              </select>
            </div>


              <div class="col-lg-2 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-tag text-info fs-6"></i> CATEGORIA:</label>
              <select v-model="from.PtoCategoria" required class="form-control tamaño2">
                <option disabled value="">
                  -- SELECCIONA UNA CATEGORIA --
                </option>
                <option :value="{
                  id: categoria.parCorrelativo,
                  categoria: categoria.parDescripcion
                }" v-for="categoria in Categorias" :key="categoria.id">
                  {{ categoria.parDescripcion }}
                </option>
              </select>
            </div>

            <div class="col-lg-1 col-sm-12 text-center">
              <label class="tamaño d-flex align-items-center justify-content-center gap-2">ARCHIVO .pdf:</label>
              <div>
                <label for="fileInput" class="icono-archivo" style="cursor: pointer;">
                  <i class="bi bi-cloud-arrow-up-fill text-primary"></i>
                </label>
                <input type="file" id="fileInput" style="display: none;" @change="handleFile" />
                <span v-if="fileName" class="d-block mt-2 small text-secondary">{{ fileName }}</span>
              </div>
            </div>

            <div class="col-lg-1 col-sm-12 text-center">
              <label class="tamaño d-flex align-items-center justify-content-center gap-2">GUARDAR:</label>
              
              <button type="submit" class="btn btn-success mt-2 ms-2" :disabled="puestoExiste">
                <i class="bi bi-floppy fs-6"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

   
    <div class="border border-1 rounded-3 p-3 mb-3">
      <div class="board d-flex gap-3 justify-content-center">
        <div v-for="(column, colIndex) in columns" :key="colIndex" class="column p-2 bg-light rounded shadow-sm"
          :style="['PROYECTOS', 'ASIGNADAS'].includes(column.name) ? 'width: 600px;' : 'width: 300px;'">
          <h5 class="text-center mb-3">{{ column.name }}</h5>

          
          <div style="max-height: 350px; overflow-y: auto;">
            <draggable v-model="column.cards" :group="{ name: 'cards', pull: true, put: true }" :options="{
              animation: 200,
              sort: true,
              fallbackOnBody: true,
              swapThreshold: 0.65,
              emptyInsertThreshold: 50
            }" @change="onCardMoved($event, column.name)" class="d-grid gap-2"
              style="grid-template-columns: repeat(2, 1fr); min-height: 100px;">

              <div v-for="card in column.cards" :key="card.id">
                <div class="card p-2 bg-white shadow-sm">
                  <p class="mb-0 reducirTamaño">{{ card.nomProyecto }}</p>
                </div>
              </div>
            </draggable>
          </div>
        </div>
      </div>
    </div>


    

    <div class="border border-1 mx-2 mt-2">

      <div class="col-12 d-flex justify-content-end mt-2">
        <div class="input-group buscar-estiloCuadrado" style="max-width: 350px; width: 100%;">
          <span for="" class="input-group-text mt-3 buscar-estiloCuadrado">
            <i class="bi bi-search"></i></span>
          <input class="form-control w-25 mt-3 me-2 buscar-estiloCuadrado" type="text"
            aria-label=".form-control-lg example" placeholder="NOMBRE" v-model="filterField" @input="filtro" />
        </div>
      </div>

      <div class="table-responsive mx-2 mt-2">
        <table class="table table-bordered">
          <thead class="reducirTamaño">
            <tr class="bg-solimano text-white text-center text-nowrap">
              <th scope="col">ID</th>
              <th scope="col">NOMBRE DEL PUESTO</th>
              <th scope="col">SECTOR</th>
              <th scope="col">CLASIFICACIÓN</th>
              <th scope="col">CATEGORIA</th>
              <th scope="col">ESTADO</th>
              <th scope="col">NOMBRE DE ESTADO</th>
              <th scope="col">DESCRIPCION</th>
              <th scope="col">ACCIÓN</th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="loading">
              <td colspan="11" class="text-center align-middle" style="height: 250px;">
                <div class="d-flex flex-column align-items-center justify-content-center h-100">
                  <div class="spinner-border text-warning" role="status" style="width: 4rem; height: 4rem;"></div>
                  <div class="mt-3 text-secondary fw-semibold fs-5">Filtrando información...</div>
                </div>
              </td>
            </tr>
            <tr v-else v-for="(post, index) in paginatedPosts" :key="post.idPuesto || index"
              class="text-center align-middle reducirTamaño">

              <td scope="row" class="text-center tabla-estiloCompreso fw-semibold text-primary">

                <i class="bi bi-person-badge-fill me-1"></i>{{ post.idPuesto }}
              </td>

              <td class="text-dark">
                <i class="bi bi-person-fill me-1 text-info"></i>{{ post.ptoNombre }}
              </td>

              <td class="text-dark">
                <i class="bi bi-building-fill me-1 text-brown" style="color: #8B4513;"></i>{{ post.ptoSector }}
              </td>

              <td class="text-dark ">
                <i class="bi bi-diagram-3-fill me-1 text-warning"></i>{{ post.ptoClasificacion }}
              </td>


                <td class="text-dark ">
                <i class="bi bi-diagram-3-fill me-1 text-warning"></i>{{ post.ptoCategoria }}
              </td>

              <!-- Estado -->
               <td v-if="post.ptoEstado == 0" class="fw-bold text-success text-center">
                                <i class="bi bi-check-circle-fill me-1"></i> VIGENTE
                            </td>
                             <td v-if="post.ptoEstado == 1" class="fw-bold text-danger text-center">
                                <i class="bi bi-check-circle-fill me-1"></i> NO VIGENTE
                            </td>
                            <td v-if="post.ptoEstado == 3" class="fw-bold text-warning text-center">
                                <i class="bi bi-x-circle-fill me-1"></i> EN PROCESO DE APROBACION
                            </td>
                              <td>
                                <span v-if="post.aprEstado === '002'" class="text-success">
                                    <i class="bi bi-check-circle-fill me-1"></i>
                                    APROBADO
                                </span>

                                <span v-else-if="post.aprEstado === '003'" class="text-danger">
                                    <i class="bi bi-x-circle-fill me-1"></i>
                                    RECHAZADO
                                </span>

                                <span v-else-if="post.aprEstado === '001'" class="text-warning">
                                    <i class="bi bi-hourglass-split me-1"></i>
                                    SOLICITUD DE APROBACIÓN
                                </span>
                            </td>
                            <td>
                                {{ post.aprDescripcion }}
                            </td>

              <td class="text-center d-flex align-items-center justify-content-center py-1">
                

                <div>
                  <label for="file-upload" class="btn btn-outline-primary boton-estiloCuadrado" @click="
                    mandarPdfServicios(post.idPuesto)
                    ">
                    <i class="bi bi-cloud-upload"></i>
                  </label>
                  <input id="file-upload" class=" " type="file" accept=".pdf" @change="handleFileUpload" ref="fileInput"
                    :key="fileInputKey" />
                </div>

                <div class="ms-2">
                  <a v-if="post.docAdjunto != ''" :href="url + post.docAdjunto.slice(49)" target="_blank">
                    <button class="btn btn-primary text-white boton-estiloCuadrado">
                      <i class="bi bi-file-earmark-pdf-fill"></i>
                    </button>

                  </a>
                  <button v-else class="btn btn-secondary text-white boton-estiloCuadrado">
                    <i class="bi bi-file-earmark-pdf-fill"></i>
                  </button>

                </div>

                <div class="mx-2" @click="cambioEstado(post.idPuesto)">
                  <button class="btn btn-outline-danger boton-estiloCuadrado">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="!loading && paginatedPosts.length === 0">
              <td colspan="11" class="text-center text-secondary py-4">
                <i class="bi bi-exclamation-triangle text-warning me-1"></i>
                No se encontraron resultados
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
    <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
      <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
        <i class="bi bi-chevron-double-left"></i>
      </button>

      <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
        <i class="bi bi-chevron-left"></i>
      </button>

      <span class="pagination-info small fw-semibold text-secondary">
        Página {{ currentPage }} de {{ totalPages }}
      </span>

      <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
        <i class="bi bi-chevron-right"></i>
      </button>

      <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
        :disabled="currentPage === totalPages">
        <i class="bi bi-chevron-double-right"></i>
      </button>
    </div>
  </div>
</template>

<!-- 0 = VIGENTE
1= NO VIGENTE -->

<script>
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";
import draggable from "vuedraggable";
export default {
  name: "SolimanologPuestosRegistrar",
  components: {
    draggable
  },

  data() {
    return {
      url: "https://apitopas.gruposolimano.com.pe/Documentos/Puestos",

      from: {
        PtoNombre: "",
        PtoSector: "",
        PtoClasificacion: "",
        DesCrea: "",
        PtoCategoria: "",
      },
      alertaError: false,
      filterField: "",
      cerrarTable1: true,
      cerrarTable2: false,
      currentPage: 1,      // ✅ Página actual
      itemsPerPage: 15,
      // retro: false,
      // avanzar: true,
      noAvanzar: false,
      noRetroceder: false,
      fileName: "",
      loading: false,
      fileInputKey: 0,
      IdPuesto: "",

      nombrePersona: "",
      nombrePuesto: "",
      sector: "",
      clasificacion: "",
      categoria: "",
      fechaCreacion: "",
      destinatarios: [], // "correo1@x.com,correo2@x.com"
      proyectos: [],
      columns: [
        { name: 'PROYECTOS', cards: [] },
        { name: 'ASIGNADAS', cards: [] }
      ],
      Categorias:[]
    };
  },

  created() {
    this.from.DesCrea = localStorage.getItem("userId");
    this.getAttributesTable();
    this.cambiarEstadoNavbar();
    this.obtenerCorreos();
    this.obtenerInformacion()
  },

  mounted() { 
    this.axios.get("ParametroData/Parametro/7975").then(response => {
     console.log("texto", response.data);
     this.Categorias = response.data
    }).catch(error => {
      console.error("Error al obtener destinatarios:", error);
    });
  },

  computed: {
    ...mapGetters("parametros", ["Sector", "Clasificacion"]),
    ...mapGetters("registroPuestos", ["Post"]),
    ...mapGetters("users", ["NombresUsers"]),

    puestoExiste() {
      if (!this.from.PtoNombre || this.from.PtoNombre.trim().length < 3) return false;

      // Función interna para normalizar: quita espacios, pasa a minúsculas y elimina tildes
      const normalizar = (texto) => 
        texto.trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

      const nombreBusqueda = normalizar(this.from.PtoNombre);
      return this.Post.some(p => normalizar(p.ptoNombre) === nombreBusqueda);
    },

    filteredPosts() {
      if (!this.filterField) return this.Post;
      const texto = this.filterField.toLowerCase();
      return this.Post.filter(p => p.ptoNombre.toLowerCase().includes(texto));
    },

    paginatedPosts() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredPosts.slice(start, start + this.itemsPerPage);
    },

    totalPages() {
      return Math.ceil(this.filteredPosts.length / this.itemsPerPage);
    },
  },

  methods: {
    onCardMoved(event, destino) {
      
      if (event.added) {
        const cardMovida = event.added.element; // aquí llega tu card completa

        console.log("Proyecto movido:", cardMovida);
        console.log("ID del proyecto:", cardMovida.id);
        console.log("Nueva columna:", destino);

        if (destino === "ASIGNADAS") {
          this.registrarAsignacion(cardMovida.id);
        }
      }
    },

    registrarAsignacion(idProyecto) {
      console.log(this.columns[1].cards, idProyecto)

      const arreglo = []; // el arreglo donde guardamos los IDs

      this.columns[1].cards.map(r => {
        arreglo.push(r.codigo);

        console.log(arreglo)


      })
    },

    ...mapActions("registroPuestos", [
      "getAttributesTable",
      "registrarPuesto",
      "modificarPuesto",
    ]),

    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

    handleFile(event) {
      this.archivoSeleccionado = event.target.files[0];
      if (this.archivoSeleccionado) {
        this.fileName = this.archivoSeleccionado.name;
      } else {
        this.fileName = "";
      }
    },

    async enviarCorreoNuevoPuesto() {
      try {
        // 🔄 Activar loading (opcional)
        // this.destinatarios = 'gvicente@gruposolimano.com.pe,cluyo@gruposolimano.com.pe'
        const payload = {
          nombrePersona: this.NombresUsers,
          nombrePuesto: this.from.PtoNombre,
          sector: this.from.PtoSector.descripcion,
          clasificacion: this.from.PtoClasificacion.descripcion,
          // categoria: this.categoria,
          destinatario: this.destinatarios  // ejemplo: "correo1@x.com,correo2@x.com"
        };

        const response = await this.axios.post(
          "PuestoData/CorreoAprobacionPuesto",
          null, // 🔥 SIN Body JSON, porque enviamos como querystring
          { params: payload }
        );
        console.log(response)

      } catch (error) {
        console.error("Error:", error);
        Swal.fire({
          icon: "error",
          title: "Error en el servidor",
          text: error.message,
        });
      }
    },

    async obtenerCorreos() {
      const perfiles = "6"; // ejemplo

      try {
        const response = await this.axios.get(
          `PuestoData/ObtenerCorreosPorPerfil?perfil=${perfiles}`
        );

        if (response.data && response.data.success) {
          this.destinatarios = response.data.correos
        }
      } catch (error) {
        console.error("❌ Error al obtener correos:", error);
      }
    },

    async guardar() {
      if (
        this.from.PtoNombre.trim() === "" ||
        this.from.PtoSector === "" ||
        this.from.PtoClasificacion === "" ||
        this.from.PtoCategoria === "" ||
        !this.archivoSeleccionado
      ) {
        // Usamos SweetAlert2 para notificar el campo faltante
        let mensaje = "Por favor, complete todos los campos.";
        if (!this.archivoSeleccionado) {
          mensaje = "El archivo .PDF es obligatorio para registrar el puesto.";
        }

        Swal.fire({
          icon: "warning",
          title: "Campos incompletos",
          text: mensaje,
          confirmButtonColor: "#3085d6",
        });
        
        return; // Detenemos la ejecución
      } else {
        const formData = new FormData();

        formData.append("ptoNombre", this.from.PtoNombre.trim());
        formData.append("PtoSector", this.from.PtoSector.id);
        formData.append("PtoClasificacion", this.from.PtoClasificacion.id);
        formData.append("DesCrea", this.from.DesCrea);
        formData.append("Archivo", this.archivoSeleccionado); // archivo tipo File
        formData.append("PtoCategoria", this.from.PtoCategoria.id);


        this.registrarPuesto(formData);
        this.enviarCorreoNuevoPuesto()
        
        // Resetear el formulario al estado inicial para limpiar los selectores
        this.from.PtoNombre = "";
        this.from.PtoSector = "";
        this.from.PtoClasificacion = "";
        this.from.PtoCategoria = "";
        this.archivoSeleccionado = null;
        this.fileName = "";
      }
    },

    async cambioEstado(IdPuesto) {
      let DesElimina = this.from.DesCrea;

      const cambiar = {
        IdPuesto,
        DesElimina,
      };
      this.modificarPuesto(cambiar);
    },

    filter(items) {
      // aqui nos aseguramos que el input contenga caracteres String y que valida
      // el v-model de this.nombre
      return (
        items.ptoNombre
          .toLocaleLowerCase()
          .indexOf(this.filterField.toLocaleLowerCase()) >= 0
      );
    },

    mandarPdfServicios(idPuesto) {
      this.IdPuesto = idPuesto
    },
    obtenerInformacion() {
      this.axios.get("PuestoData/ObtenerProyectos")
        .then(response => {
          const proyectos = response.data;
          console.log("Proyectos", proyectos);

          // Asignamos todos los proyectos a 'PROYECTOS', puedes modificar esta lógica
          this.columns.forEach(column => {
            if (column.name === 'PROYECTOS') {
              column.cards = proyectos;
            } else {
              column.cards = [];
            }
          });
        })
        .catch(error => {
          console.error("Error al obtener proyectos:", error);
        });
    },

    handleFileUpload(event) {
      const file = event.target.files[0];

      // Prepara los datos para enviar
      const formData = new FormData();
      formData.append("idPuesto", this.IdPuesto);
      formData.append("archivo", file);

      console.log("📦 Subiendo archivo PDF para idPuesto:", this.IdPuesto);


      // Llamada Axios
      this.axios
        .put("PuestoData/ModificarDocumentoPuesto", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          console.log("✅ Respuesta del servidor:", response.data);

          if (response.data.estado) {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Se Registró Correctamente',
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              // 🔥 Esto se ejecuta cuando termina el Swal
              this.getAttributesTable();
            });
          } else {
            alert("⚠️ " + response.data.mensaje);
          }

          // Reinicia el input de archivo
          this.fileInputKey += 1;
        })
        .catch((error) => {
          console.error("❌ Error al subir PDF:", error);
          alert("❌ Ocurrió un error al subir el archivo.");
        });

    },

    regresar() {
      this.$router.push("/");
    },
    filtro() {
      this.loading = true;
      setTimeout(() => {
        this.currentPage = 1;
        this.loading = false;
      }, 900);
    },


  },
};
</script>

<style scoped>
.reducirTamaño {
  font-size: 0.65rem;
}

.bg-solimano {
  background: #1565c0;
}

.tituloResaltado {
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.boton-estiloPag {
  border: 1px solid rgb(199, 199, 199);
  background-color: white;
  color: rgb(32, 32, 32);
  padding: 0.6rem 1rem;
  border-radius: 0;
}

.boton-estiloCuadrado {
  padding: 0.2rem 0.55rem;
  cursor: pointer;
  /* Cambia el cursor a una mano */
}

.buscar-estiloCuadrado {
  border-radius: 0;
  font-size: 0.65rem;
  background-color: transparent;
  /* Fondo transparente */
}

.tabla-estiloCompreso {
  padding: 0.3rem 0.55rem;
}

.tamaño {
  font-size: 0.70rem;

  font-weight: 800;
  color: #002c5d;
}

.tamaño2 {
  font-size: 0.70rem;

  font-weight: 600;
}
.icono-archivo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  border: 2px solid #0d6efd;
  /* color azul Bootstrap */
  border-radius: 50%;
  /* forma circular */
  transition: 0.3s;
}

.icono-archivo:hover {
  background-color: #0d6efd;
}

.icono-archivo:hover i {
  color: white !important;
}

.icono-archivo i {
  font-size: 1.4rem;
}

#file-upload {
  display: none;
}

.board {
  display: flex;
}

.column {
  flex-shrink: 0;
}

.card {
  border-radius: 5px;
}
</style>
